import styled from "styled-components";

export const StyledLoadingMessage = styled.div`
    margin-top: 1rem;
    display: flex;
    justify-content: center;
    font-family: "Open Sans", sans-serif;
    font-size: 10px;
    color: #9ca3af;
    font-weight: 400;
`;
